import React from "react";
import { Dropdown } from "react-bootstrap";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import useAppStore from "../../store/global";
import { Filter } from "react-bootstrap-icons";
import { useSearchParams, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { queryClient } from "../../App";
import instance from "../api/api";
import { API_URL } from "../../config";

export const useFetchUniquePoSCategories = (restaurantId) => {
  return useQuery({
    placeholderData: (previousData, q) => previousData,
    queryKey: ["uniquePoSCategories", restaurantId],
    queryFn: async () => {
      try {
        const postData = {
          restaurant_id: restaurantId,
        };

        const response = await instance.post(
          `${API_URL}/get-unique-pos-categories-for-a-restaurant`,
          postData
        );
        const data = response.data.unique_pos_categories;

        return data;
      } catch (error) {
        throw error;
      }
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.ensureQueryData(
        ["uniquePoSCategories", variables.restaurantId],
        data
      );
    },
  });
};

export default function FilterDropdown({ setPageIndex }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const posCategory = searchParams.get("pos_category");
  const restaurant_name = searchParams.get("restaurant_name");
  const { id } = useParams();
  const { data, isLoading, isError, error } = useFetchUniquePoSCategories(id);
  const {
    dateRange,
    setDateRange,
    reportType,
    setReportType,
  } = useAppStore();
  const { pathname } = useLocation();
  const route = pathname.split("/")[3];
  console.log(dateRange);
  return (
    <Dropdown autoClose={"outside"}>
      <Dropdown.Toggle
        variant="outline"
        className="border w-100 h-100 bg-body"
        style={{
          lineHeight: "1.2",
          fontSize: "14px",
        }}
      >
        <Filter className="mx-2" />
        Select Filter
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="flex-d flex-col p-2"
        style={{
          gap: "10px",
          maxHeight: "calc(100vh - 80px)",
          overflowY: "auto",
        }}
      >
        <label htmlFor="dateRange">Date Range</label>
        <DateRange
          id="dateRange"
          editableDateInputs={true}
          onChange={(item) => {
            setPageIndex(1);
            setDateRange([item.selection]);
          }}
          moveRangeOnFirstSelection={false}
          ranges={dateRange}
          format="yyyy-MM-dd"
        />
        {(route === "labour-reports" ||
          route === "discount-reports" ||
          route === "pmix-reports" ||
          route === "sales-reports") && (
          <>
            <label htmlFor="Report Type">Report Type</label>
            <select
              className="form-control"
              defaultValue={reportType}
              onChange={(e) => {
                setPageIndex(1);
                setReportType(e.target.value);
              }}
            >
              <option value={null}>All</option>
              <option value="daily">Daily Report</option>
              <option value="monthly">Monthly Report</option>
            </select>
          </>
        )}
        {route === "menu-mix" && (
          <>
            <label htmlFor="posCategories">POS Categories</label>
            <Dropdown>
              <Dropdown.Toggle
                variant="light"
                className="border w-100 h-120 bg-white"
                style={{
                  lineHeight: "1.2",
                  textAlign: "left",
                  fontSize: "14px",
                  textTransform: "capitalize",
                }}
              >
                {posCategory ? posCategory : "Select POS Category"}
              </Dropdown.Toggle>
              <Dropdown.Menu
                className="flex-d flex-col p-2"
                style={{
                  gap: "10px",
                  maxHeight: "200px",
                  overflowY: "auto",
                }}
              >
                <Dropdown.Item
                  onClick={() => {
                    setSearchParams({ restaurant_name: restaurant_name });
                  }}
                >
                  All
                </Dropdown.Item>
                {isLoading && <Dropdown.Item>Loading...</Dropdown.Item>}
                {isError && (
                  <Dropdown.Item>
                    Error fetching data, {error.message}
                  </Dropdown.Item>
                )}
                {data &&
                  data?.map((category) => (
                    <Dropdown.Item
                      key={category}
                      onClick={() => {
                        setSearchParams({
                          ...searchParams,
                          pos_category: category,
                          restaurant_name: restaurant_name,
                        });
                      }}
                    >
                      {category}
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
